import { useTranslation } from 'react-i18next';
import { TrashIcon } from '@heroicons/react/24/outline';

import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import IconButton from '@/components/ui/custom/buttons/IconButton';

type Props = {
  disabled?: boolean;
  onRemove(): void;
};

export default function RemoveResourceButton(props: Props) {
  const [t] = useTranslation('translation', {
    keyPrefix: 'common',
  });

  const { t: editRulesT } = useTranslation('translation', {
    keyPrefix: 'adminPage.editCourseRules',
  });

  const { disabled, onRemove } = props;

  return (
    <Tooltip
      text={disabled ? editRulesT('cantModify') : t('remove')}
      className="h-fit"
      classNameContainer="flex items-center"
    >
      <IconButton
        disabled={disabled}
        testId="removeResourceButton"
        className="text-primary flex-row-reverse gap-1 font-500"
        color="custom"
        onClick={onRemove}
        icon={<TrashIcon className="w-4 h-4 text-error" />}
      />
    </Tooltip>
  );
}
